<template>
  <a-modal
    :visible="visible"
    :title="$t('inscription.downloadTitle')"
    @cancel="closeModal"
  >
    <p>{{ $t("menu.listeActivites") }}</p>
    <a-select
      mode="multiple"
      show-search
      :placeholder="$t('paiement.listeActivites')"
      style="width: 100%"
      option-filter-prop="children"
      :filter-option="filterOption"
      v-model="selectedValues"
    >
      <a-select-option
        v-for="activtiy in activities"
        :key="activtiy._id"
        :value="activtiy._id"
      >
        {{ activtiy.designation }}
      </a-select-option>
    </a-select>

    <a-divider />
    <p class="font-weight-bold mb-1">
      {{ $t("ficheClasse.parentSheetSelectColumnsTitle") }}
    </p>
    <p class="text-muted mb-3">
      {{ $t("inscription.activityListSelectColumnsHint") }}
    </p>
    <div class="mb-3">
      <a-button size="small" class="mr-2" @click="selectAllColumns">
        {{ $t("payment.selectAll") }}
      </a-button>
      <a-button size="small" @click="deselectAllColumns">
        {{ $t("payment.deselectAll") }}
      </a-button>
    </div>
    <a-checkbox-group v-model="selectedColumns" style="width: 100%">
      <a-row>
        <a-col
          v-for="col in columnOptions"
          :key="col.key"
          :span="12"
          class="mb-2"
        >
          <a-checkbox :value="col.key">
            {{ $t(col.labelKey) }}
          </a-checkbox>
        </a-col>
      </a-row>
    </a-checkbox-group>
    <template #footer>
      <a-button key="back" @click="closeModal">{{
        $t("action.annuler")
      }}</a-button>
      <a-button
        key="submit"
        type="primary"
        :disabled="selectedValues.length === 0 || selectedColumns.length === 0"
        :loading="loading"
        @click="download()"
      >
        {{ $t("action.imprimer") }}</a-button
      >
    </template>
  </a-modal>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { mapState } from "vuex";
import { isKenyanSchool } from "@/utilities/countrySpecific";

const DEFAULT_COLUMNS = ["fullName", "classroom", "parentName", "phone"];

const COLUMN_WEIGHTS = {
  fullName: 1.4,
  fullNameFr: 1.4,
  uniqueId: 1,
  birthDate: 1.1,
  classroom: 1,
  group: 1,
  parentName: 1.7,
  phone: 1.5,
  email: 1.6,
  address: 1.5,
};

export default {
  data() {
    return {
      activities: [],
      classList: [],
      selectedActivities: [],
      selectedValues: [],
      selectedColumns: [...DEFAULT_COLUMNS],
      loading: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState(["settings"]),
    columnOptions() {
      const countryIsKE = isKenyanSchool();
      return [
        { key: "fullName", labelKey: "ficheClasse.nomPrenom" },
        ...(!countryIsKE
          ? [{ key: "fullNameFr", labelKey: "ficheClasse.nomPrenomFr" }]
          : []),
        {
          key: "uniqueId",
          labelKey: countryIsKE
            ? "profil.nemisNumber"
            : "ficheClasse.identifiantUnique",
        },
        { key: "birthDate", labelKey: "ficheClasse.dateNaissance" },
        { key: "classroom", labelKey: "ficheClasse.classe" },
        { key: "parentName", labelKey: "ficheClasse.nomParent" },
        { key: "phone", labelKey: "ficheClasse.telephone" },
        { key: "email", labelKey: "liste.email" },
        { key: "address", labelKey: "liste.adresse" },
        { key: "group", labelKey: "ficheClasse.group" },
      ];
    },
  },
  async created() {
    apiClient
      .post("/activities/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            designation: 1,
          },
        },
      })
      .then((res) => {
        this.activities = res.data;
      })
      .catch((e) => this.$message.error(this.$t("error.aucActivite")));
    apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            name: 1,
            level: 1,
          },
        },
      })
      .then((res) => (this.classList = res.data))
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async handleActivities() {
      const promises = this.selectedValues.map((activityId) => {
        return apiClient
          .get("/payment/etatImpaye/activity/" + activityId)
          .then((res) => {
            const activity = this.activities.find((a) => a._id === activityId);
            return {
              activityId: activityId,
              activityName: activity && activity.designation,
              students: res.data.map((student) => ({
                studentId: student.studentId,
                studentName: student.student,
                studentFullNameFr: student.studentFullNameFr,
                uniqueId: student.uniqueId,
                nemisNumber: student.nemisNumber,
                birthDate: student.birthDate,
                classroom: student.classroom,
                groupName: student.groupName,
                parentNames: student.parentNames || {},
                phones: student.phones || {},
                emails: student.emails || {},
                address: student.address,
              })),
            };
          })
          .catch((e) => {
            console.log(e);
            return null;
          });
      });

      this.selectedActivities = (await Promise.all(promises)).filter(Boolean);
    },
    closeModal() {
      this.loading = false;
      this.selectedActivities = [];
      this.selectedValues = [];
      this.selectedColumns = [...DEFAULT_COLUMNS];
      this.$emit("close");
    },
    selectAllColumns() {
      this.selectedColumns = this.columnOptions.map((col) => col.key);
    },
    deselectAllColumns() {
      this.selectedColumns = [];
    },
    getOrderedSelectedColumns() {
      const columnOrder = this.columnOptions.map((col) => col.key);
      return this.selectedColumns
        .filter((key) => columnOrder.includes(key))
        .sort((a, b) => columnOrder.indexOf(a) - columnOrder.indexOf(b));
    },
    getColumnHeader(columnKey) {
      const option = this.columnOptions.find((col) => col.key === columnKey);
      return option ? this.$t(option.labelKey) : columnKey;
    },
    formatDualValue(values, isArabic) {
      const father = values?.father || "";
      const mother = values?.mother || "";
      if (!father || !mother) return father || mother || "--";

      const fatherLabel = this.$t("ficheClasse.pere");
      const motherLabel = this.$t("ficheClasse.mere");
      if (isArabic && !/[\u0600-\u06FF]/.test(father + mother)) {
        return `${father} : ${fatherLabel}\n${mother} : ${motherLabel}`;
      }
      return `${fatherLabel} : ${father}\n${motherLabel} : ${mother}`;
    },
    getColumnValue(student, columnKey, isArabic) {
      switch (columnKey) {
        case "fullName":
          return student.studentName || "--";
        case "fullNameFr":
          return student.studentFullNameFr || "--";
        case "uniqueId":
          return isKenyanSchool()
            ? student.nemisNumber || "--"
            : student.uniqueId || "--";
        case "birthDate":
          return student.birthDate
            ? moment(student.birthDate).format("DD/MM/YYYY")
            : "--";
        case "classroom":
          return student.classroom || "--";
        case "group":
          return student.groupName || "--";
        case "parentName":
          return this.formatDualValue(student.parentNames, isArabic);
        case "phone":
          return this.formatDualValue(student.phones, isArabic);
        case "email":
          return this.formatDualValue(student.emails, isArabic);
        case "address":
          return student.address || "--";
        default:
          return "--";
      }
    },
    async download() {
      if (!this.selectedColumns.length) {
        this.$message.warning(
          this.$t("ficheClasse.parentSheetSelectAtLeastOneColumn")
        );
        return;
      }
      this.loading = true;
      try {
        await this.handleActivities();
        // Filter out activities with no students
        const activitiesWithStudents = this.selectedActivities.filter(
          (activity) => activity.students && activity.students.length > 0
        );

        const emptyActivities = this.selectedActivities.filter(
          (activity) => !activity.students || activity.students.length === 0
        );

        if (activitiesWithStudents.length > 0) {
          // If there are some activities with students but also some empty ones
          if (emptyActivities.length > 0) {
            const emptyActivityNames = emptyActivities
              .map((activity) => activity.activityName)
              .join(", ");
            this.$message.warning(
              this.$t("inscription.noStudentInActivity") +
                `: ${emptyActivityNames}`,
              5
            );
          }
          this.generatePDF(activitiesWithStudents);
        } else {
          this.loading = false;
          // If all selected activities are empty
          this.$message.warning(this.$t("inscription.unableToGeneratePdf"), 5);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    pdfHeader(doc, subTitle) {
      const title = this.$t("inscription.studentsList");
      let arrayOfImages = this.settings.image;
      let imgData = new Image();
      const isArabic = this.$i18n.locale === 'ar-AR';

      for (let i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          imgData.src = arrayOfImages[i].logo;
          break;
        }
      }

      doc.setFont("Amiri");

      const date = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      // Center the title
      const pageWidth = doc.internal.pageSize.getWidth();
      
      doc.setFontSize(15);
      doc.setFont("Amiri", "Bold");
      const titleWidth = doc.getTextWidth(title);
      const titleX = (pageWidth - titleWidth) / 2;
      doc.text(titleX, 22, title);
      doc.setFont("Amiri", "normal");
      
      if (subTitle) {
        // Set font size first, then calculate width
        doc.setFontSize(12);
        let subTitleWidth = doc.getTextWidth(subTitle);
        let subTitleX = (pageWidth - subTitleWidth) / 2;

        // Add the subtitle to the document
        doc.text(subTitleX, 29, subTitle);
      }
      
      doc.setFontSize(10);

      try {
        if (imgData.src) {
          // Position logo based on language direction
          const logoX = isArabic ? pageWidth - 35 : 15; // Right for Arabic, left for others
          doc.addImage(imgData, "JPEG", logoX, 5, 20, 20);
        }
      } catch (error) {
        console.log(error);
      }

      doc.setFontSize(8);
      const dateText = date.toLocaleDateString(this.$i18n.locale, options);
      const dateTextWidth = doc.getTextWidth(dateText);
      // Position date based on language direction
      const dateX = isArabic ? 15 : pageWidth - dateTextWidth - 15; // Left for Arabic, right for others
      doc.text(dateX, 15, dateText);
    },
    generatePDF(activities) {
      const doc = new JsPDF();
      const margin = 7;
      const pageWidth = doc.internal.pageSize.width;
      const tableWidth = pageWidth - 2 * margin;
      let totalPages = 0;
      const isArabic = this.$i18n.locale === 'ar-AR';
      const columns = this.getOrderedSelectedColumns();

      activities.forEach((activity, activityIndex) => {
        // Add new page for subsequent activities
        if (activityIndex > 0) {
          doc.addPage();
        }
        // Create header for each activity
        this.pdfHeader(doc, activity.activityName);
        // Process data to include classroom names
        const processedData = activity.students.map((student) => {
          const classInfo = this.classList.find(
            (c) => c._id === student.classroom
          ) || { name: "--" };
          return {
            ...student,
            classroom: classInfo.name,
            level: classInfo.level,
          };
        });

        // Sort by classroom level and name
        processedData.sort((a, b) => {
          if (a.level < b.level) return -1;
          if (a.level > b.level) return 1;
          if (a.classroom < b.classroom) return -1;
          if (a.classroom > b.classroom) return 1;
          return 0;
        });

        const reverseIfArabic = (arr) => isArabic ? arr.slice().reverse() : arr;

        const tableData = processedData.map((student, index) =>
          reverseIfArabic([
            index + 1,
            ...columns.map((columnKey) =>
              this.getColumnValue(student, columnKey, isArabic)
            ),
          ])
        );

        const tableHeaders = reverseIfArabic([
          this.$t("inscription.num"),
          ...columns.map((columnKey) => this.getColumnHeader(columnKey)),
        ]);

        const fontSize =
          columns.length <= 4 ? 10 : columns.length <= 6 ? 8.5 : 7;

        const numeroColWidth = 10;
        const dataWidth = tableWidth - numeroColWidth;
        const totalWeight = columns.reduce(
          (total, columnKey) => total + (COLUMN_WEIGHTS[columnKey] || 1),
          0
        );
        const orderedStyles = reverseIfArabic([
          { cellWidth: numeroColWidth, halign: "center" },
          ...columns.map((columnKey) => ({
            cellWidth:
              dataWidth * ((COLUMN_WEIGHTS[columnKey] || 1) / totalWeight),
          })),
        ]);
        const columnStyles = {};
        orderedStyles.forEach((style, index) => {
          columnStyles[index] = style;
        });

        doc.autoTable({
          startY: 45,
          theme: "grid",
          head: [tableHeaders],
          body: tableData,
          tableWidth,
          margin: { left: margin, right: margin },
          styles: {
            font: "Amiri",
            halign: isArabic ? "right" : "left",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
            fontSize,
            cellPadding: 1.5,
            overflow: "linebreak",
          },
          headStyles: {
            halign: isArabic ? "right" : "left",
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
            fontStyle: "bold",
          },
          bodyStyles: {
            halign: isArabic ? "right" : "left",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
          },
          columnStyles,
        });
      });

      // Get total number of pages
      totalPages = doc.internal.getNumberOfPages();

      // Now add page numbers to all pages
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const text = this.$t("pdf.pageNumber", {
          current: i,
          total: totalPages,
        });
        doc.setFontSize(10);

        // Calculate center position
        const textWidth = doc.getTextDimensions(text).w;
        const textX = (doc.internal.pageSize.width - textWidth) / 2;

        doc.text(text, textX, doc.internal.pageSize.height - 10);
      }

      this.closeModal();
      doc.save(this.$t("inscription.activityList") + ".pdf");
    },
  },
};
</script>
